export enum Keys {
  ENTER = "Enter",
  BACKSPACE = "Backspace",
  ArrowDown = "ArrowDown",
  ArrowUp = "ArrowUp",
  Esc = "Escape",
}

export enum SpecialKeys {
  CTRL = "ctrlKey",
  SHIFT = "shiftKey",
  ALT = "altKey",
}
